import React, { useEffect } from 'react';

import AirportAutocomplete from 'component/Search/Airport';
import { CustomSearchInputClassList } from 'component/Search/Input/types';

import { Feature } from 'config/features';
import { useSetAtom } from 'jotai';

import { useDepartureAirport } from 'hooks/form/search';
import { useFeature } from 'hooks/useFeature';

import { refreshNoteVisibility } from 'data/Atom/Component';

import { Iata } from 'types/Search/airport';
import { AirportValue } from 'types/Search/filter';
import { ValidationType } from 'types/Search/form';

interface AirportProps {
    initialValue?: AirportValue<Iata>;
    placeholder: string;
    label: string;
    customClassList?: CustomSearchInputClassList;
    onValidate?: (type: ValidationType, isEmpty: boolean) => void;
}

const Airport = ({
    initialValue,
    placeholder,
    label,
    customClassList,
    onValidate,
}: AirportProps) => {
    const [airportValue, setAirportValue] = useDepartureAirport();
    const setIsVisible = useSetAtom(refreshNoteVisibility);
    const isS1S4MandatoryActive = useFeature(Feature.S1S4Mandatory);

    useEffect(() => {
        if (initialValue) {
            setAirportValue(initialValue);
            setIsVisible(false);
        }
    }, [initialValue, setAirportValue, setIsVisible]);

    const onAirportChange = (value: AirportValue<Iata>) => {
        setAirportValue(value);
        (!isS1S4MandatoryActive || value.size > 0) && setIsVisible(true);
        onValidate?.(ValidationType.DepartureAirport, value.size === 0);
    };

    return (
        <AirportAutocomplete
            airportValue={airportValue}
            onValueChange={onAirportChange}
            placeholder={placeholder}
            label={label}
            customClassList={customClassList}
        />
    );
};

export default Airport;
